//! Pattern: MESSAGE_<origin>_<destination>_<type>
// Id values in messages FROM pim
export const IDG_ROLE_ATTESTATION_DONE_FROM_PIM = 'MESSAGE_PIM_DASHBOARD_IDG_ROLE_ATTESTATION_DONE';
export const PARENT_WINDOW_OBJ_FROM_PIM = 'MESSAGE_PIM_DASHBOARD_WINDOW_OBJ';
export const MESSAGE_DASHBOARD_DEMOGRAPHICS_UPDATED_FOM_PIM = 'MESSAGE_PIM_DASHBOARD_DEMOGRAPHICS_UPDATED';
export const SET_IDG_RENDER_INSTRUCTIONS = 'SET_IDG_RENDER_INSTRUCTIONS';
export const COMPLETED = 'COMPLETED'; // Id values in messages TO pim : update patient header

export const UPDATE_PATIENT_HEADER_TO_PIM = 'MESSAGE_DASHBOARD_PIM_UPDATE_PATIENT_HEADER'; // Id values in messages TO pim : saving idg to manifest failed

export const MESSAGE_DASHBOARD_SAVE_MANIFEST_FAILED = 'MESSAGE_DASHBOARD_SAVE_MANIFEST_FAILED'; // Id values in messages TO pim : saving idg to manifest complete

export const MESSAGE_DASHBOARD_SAVE_MANIFEST_COMPLETE = 'MESSAGE_DASHBOARD_SAVE_MANIFEST_COMPLETE';
export const MESSAGE_DASHBOARD_DOWNLOAD_COMPLETE = 'MESSAGE_DASHBOARD_DOWNLOAD_COMPLETE';
export const MESSAGE_DASHBOARD_PUT_SUCCESS = 'MESSAGE_DASHBOARD_PUT_SUCCESS'; // Id values in messages TO pim : add caregivers upon discharge

export const UPDATE_PIM_PATIENT_DISCHARGE = 'MESSAGE_DASHBOARD_PIM_PATIENT_DEATH_DISCHARGE';
/** Document-on-visit: tell PIM to block patient switch while SmartChart is documenting. */

export const MESSAGE_DASHBOARD_PIM_LOCK_PATIENT = 'MESSAGE_DASHBOARD_PIM_LOCK_PATIENT';
/** Document-on-visit: tell PIM documenting ended (Close path). */

export const MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT = 'MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT';
/** PIM → dashboard: user tried another patient while document lock is active. */

export const MESSAGE_PIM_DASHBOARD_PATIENT_SWITCH_REQUEST_PENDING = 'MESSAGE_PIM_DASHBOARD_PATIENT_SWITCH_REQUEST_PENDING'; // For controlling PimMessagingContext state

export const CLEAR_IDG_MESSAGES = 'PimMessagingContext.CLEAR_IDG_MESSAGES';
export const IDG_REVIEW_COMPLETE_FROM_PIM = 'PimMessagingContext.IDG_REVIEW_COMPLETE_FROM_PIM'; // Message origins

export const DASHBOARD = 'DASHBOARD';
export const PIM = 'PIM'; // Hash holding descriptions of messages TO pim

export const DescriptionHash = {
  [UPDATE_PATIENT_HEADER_TO_PIM]: 'update the patient header in PIM',
  [UPDATE_PIM_PATIENT_DISCHARGE]: 'Navigate to Care Givers TAB',
  [MESSAGE_DASHBOARD_SAVE_MANIFEST_FAILED]: 'saving the idg document to manifest failed',
  [MESSAGE_DASHBOARD_SAVE_MANIFEST_COMPLETE]: 'saving the idg document to manifest completed',
  [MESSAGE_DASHBOARD_PIM_LOCK_PATIENT]: 'document visit active — block patient switch in PIM',
  [MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT]: 'document visit ended — allow patient switch in PIM',
  [MESSAGE_DASHBOARD_PUT_SUCCESS]: 'document visit put success'
};